export default __webpack_public_path__ + "static/media/gmail.a6980c8f.svg";